import { UUID } from 'crypto'
import { DevelopusTreeTableItemType } from '../DevelopusTreeTableRow'
import DevelopusTreeTableBodyUIModel from './DevelopusTreeTableBodyUIModel'
import DevelopusTreeTableCellsUIModel from './DevelopusTreeTableCellsUIModel'

class DevelopusTreeTableRowUIModel {
  constructor(
    id: UUID | undefined,
    cells: DevelopusTreeTableCellsUIModel,
    children: DevelopusTreeTableBodyUIModel,
  ) {
    this.id = id
    this.cells = cells
    this.children = children
  }

  private readonly id?: UUID
  private readonly cells: DevelopusTreeTableCellsUIModel
  private readonly children: DevelopusTreeTableBodyUIModel

  toUI(): DevelopusTreeTableItemType {
    return {
      id: this.id,
      cells: this.cells.toUI(),
      children: this.children.toUI(),
    }
  }
}

export default DevelopusTreeTableRowUIModel
